
import { useOceanStore } from '@/store/ocean'
import { mapStores } from 'pinia'
import Vue from 'vue'

export default Vue.extend({
	props: {
		page: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapStores(useOceanStore),
		isOcean() {
			return this.oceanStore.isOcean
		},
		isSessionExpired() {
			return this.oceanStore.errorCode === 'EXPIRED_SIGNATURE'
		}
	}
})
